import { getNumberOfSavedResources } from '../../primary-nav-rse/js/global';
import SavedResource from './SavedResource';

function containsObject(obj, list) {
    for (let i = 0; i < list.length; i++) {
        if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
            return true;
        }
    }
    return false;
}

function toggleSaveButtons() {
    const saveButton = document.querySelector('.js-save-resource');
    const forgetButton = document.querySelector('.js-forget-resource');

    saveButton.classList.toggle('hide');
    forgetButton.classList.toggle('hide');
}

function createSavedAlert(undoCallback) {
    // Create the alert container
    const alert = document.createElement('div');
    alert.classList.add('resource-alert');
    alert.setAttribute('role', 'alert');

    // Create the content of the alert
    alert.innerHTML = `
        <div class="resource-alert__progress-bar"></div>
        <div class="resource-alert__icon">
                <svg
                    width="16"
                    height="21"
                    viewBox="0 0 16 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0.685864 20.9934C0.301923 20.9775 0 20.6616 0 20.2777V2.62417C0 1.18255 1.18255 0 2.62417 0H12.6437C14.0854 0 15.2679 1.18255 15.2679 2.62417V20.2777C15.2698 20.5386 15.1291 20.78 14.9008 20.9077C14.6724 21.0353 14.3938 21.0279 14.172 20.889L7.63401 16.8335L1.096 20.889C0.972991 20.9645 0.830408 21.0008 0.685959 20.9934L0.685864 20.9934ZM1.43137 18.9954L7.25369 15.3798C7.48573 15.2344 7.78113 15.2344 8.01411 15.3798L13.8364 18.9954V2.62417C13.8364 1.95136 13.3164 1.43137 12.6436 1.43137H2.62405C1.95124 1.43137 1.43125 1.95136 1.43125 2.62417L1.43137 18.9954Z"
                        fill="#1E0564"
                    />
                    <path
                        d="M14.4059 0.568359L1.10156 1.08691V20.791L8.01984 16.5336L14.8647 20.2955L14.4059 0.568359Z"
                        fill="#1E0564"
                    />
                    <path
                        d="M4.625 9L6.875 11.25L11.375 6.75"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <div class="resource-alert__content">
                <h4>This resource has been saved to 'My Resources'</h4>
                <p>
                    Find your saved resources each time you return back on this device.
                </p>
                <a href="#" class="resource-alert__undo-link">Undo</a>
            </div>
            <div class="resource-alert__button">
                <button class="close-alert">
                    <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M15.8985 2.72572C16.3324 2.29181 16.3324 1.58829 15.8985 1.15438C15.4646 0.72046 14.7611 0.72046 14.3272 1.15438L8.38541 7.09613L2.44692 1.15764C2.013 0.72372 1.30948 0.723719 0.875568 1.15764C0.441652 1.59155 0.441652 2.29507 0.875567 2.72898L6.81406 8.66748L0.875567 14.606C0.441651 15.0399 0.441652 15.7434 0.875567 16.1773C1.30948 16.6112 2.013 16.6112 2.44692 16.1773L8.38541 10.2388L14.3272 16.1806C14.7611 16.6145 15.4646 16.6145 15.8985 16.1806C16.3324 15.7467 16.3324 15.0432 15.8985 14.6092L9.95676 8.66748L15.8985 2.72572Z"
                            fill="#1E0564"
                        />
                    </svg>
                </button>
            </div>
        </div>
    `;

    // Append the alert to the body
    document.body.appendChild(alert);

    // Event listener for the close button
    alert.querySelector('.close-alert').addEventListener('click', () => {
        alert.remove();
    });

    // Event listener for the undo link
    alert
        .querySelector('.resource-alert__undo-link')
        .addEventListener('click', (e) => {
            e.preventDefault();
            undoCallback();
            alert.remove();
        });

    // Automatically remove the alert after after 5s
    setTimeout(() => {
        alert.remove();
    }, 5000);
}

function removeFromSavedResourcesInLocalStorage(newObject) {
    /* get savedResources local storage array */
    let savedResourcesArray = JSON.parse(
        window.localStorage.getItem('savedResources')
    );

    const indexOfExisting = savedResourcesArray.findIndex(
        (item) => item.assetId === newObject.assetId
    );

    if (indexOfExisting > -1) {
        savedResourcesArray.splice(indexOfExisting, 1);
        if (!savedResourcesArray) {
            savedResourcesArray = [];
        }
        window.localStorage.setItem(
            'savedResources',
            JSON.stringify(savedResourcesArray)
        );
        toggleSaveButtons();
        getNumberOfSavedResources();
    }
}

function addToSavedResourcesInLocalStorage(newObject) {
    const savedResourcesArray =
        JSON.parse(window.localStorage.getItem('savedResources')) || [];

    savedResourcesArray.push(newObject);

    window.localStorage.setItem(
        'savedResources',
        JSON.stringify(savedResourcesArray)
    );
    toggleSaveButtons();
    getNumberOfSavedResources();

    // Show the saved alert
    createSavedAlert(() => {
        removeFromSavedResourcesInLocalStorage(newObject);
    });
}

export default function _saveResource() {
    if (window.localStorage.getItem('savedResources') == null) {
        window.localStorage.setItem('savedResources', '[]');
    }

    const saveButton = document.querySelector('.js-save-resource');
    const forgetButton = document.querySelector('.js-forget-resource');

    if (saveButton || forgetButton) {
        /* Get data from <meta> tags */
        const assetId = document
            .querySelector('meta[name="assetId"]')
            .getAttribute('content');
        const link = document
            .querySelector('meta[name="resource.tile.link"]')
            .getAttribute('content');

        const featureCard = document
            .querySelector('meta[name="resource.tile.feature.card"]')
            .getAttribute('content');
        const imageUrl = document
            .querySelector('meta[name="resource.tile.image"]')
            .getAttribute('content');
        const imageUrlForDetailsPage = document
            .querySelector('meta[name="resource.page.image"]')
            .getAttribute('content');
        const partnerLogo = document
            .querySelector('meta[name="resource.tile.partner.logo"]')
            .getAttribute('content');
        const overflowImage = document
            .querySelector('meta[name="resource.tile.overflow.image"]')
            .getAttribute('content');
        const pageTitle = document
            .querySelector('meta[name="resource.tile.title"]')
            .getAttribute('content');
        const text = document
            .querySelector('meta[name="resource.tile.text"]')
            .getAttribute('content');
        const downloadLink = document
            .querySelector('meta[name="resource.tile.download.link"]')
            .getAttribute('content');
        const websiteLink = document
            .querySelector('meta[name="resource.tile.website.link"]')
            .getAttribute('content');

        const type = document
            .querySelector('meta[name="resource.tile.type"]')
            .getAttribute('content');
        const tags = document
            .querySelector('meta[name="resource.tile.tags"]')
            .getAttribute('content');
        const stage = document
            .querySelector('meta[name="resource.tile.stage')
            .getAttribute('content');
        const gradeLevel = document
            .querySelector('meta[name="resource.tile.grade.level')
            .getAttribute('content');
        const learningMode = document
            .querySelector('meta[name="resource.tile.learning.mode')
            .getAttribute('content');

        /* Create new object from data in <meta> tags */
        const newSavedData = new SavedResource(
            assetId,
            link,
            featureCard,
            imageUrl,
            imageUrlForDetailsPage,
            partnerLogo,
            overflowImage,
            pageTitle,
            text,
            downloadLink,
            websiteLink,
            type,
            tags,
            stage,
            gradeLevel,
            learningMode
        );

        /* Check if this page is already saved */
        const savedResources = JSON.parse(
            window.localStorage.getItem('savedResources')
        );
        const alreadyPresent = containsObject(newSavedData, savedResources);

        if (alreadyPresent) {
            toggleSaveButtons();
        }

        forgetButton.addEventListener('click', () => {
            removeFromSavedResourcesInLocalStorage(newSavedData);
        });
        saveButton.addEventListener('click', () => {
            addToSavedResourcesInLocalStorage(newSavedData);
        });
    }
}

window.addEventListener('DOMContentLoaded', _saveResource);
